import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import EvaluatorPaymentViewsEnum from '../../../../Enums/EvaluatorPaymentViewsEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';
import selectHelper from '../../../../Helpers/selectHelper';
import UserService from '../../../../Services/userService';
import AssignmentPaymentsAdminSearchParams from '../../../Operations/AssignmentPayments/AssignmentPaymentsAdminSearchParams';

export default class ThirdPartyJobPaymentsAdminSearchParams extends SearchParamsBase {
  initialize() {
    this.View = EvaluatorPaymentViewsEnum.PendingApproval;
    this.TabType = this.tabType;
    this.ThirdPartyJobId = '';
    this.ThirdPartySource = '';
    this.StatusCodeLookupValue = [];
    this.TpEvaluatorNameOrId = '';
    this.TpEvaluatorEmail = '';
    this.ClientNameOrId = '';
    this.ProjectNameOrId = '';
    this.TypeText = [];
    this.SelectedTpJobCountryCodes = [];
    this.SelectedPaymentOffices = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.SelectedThirdPartyJobStatuses = [];
    this.CreatedBy = '';
    this.EmptyPayment = '';
    this.TpEvaluatorTpJobPaymentId = '';
    this.AssignedTo = '';
    this.HasExportPayment = '';
    this.UrlModifiableParams = ['View'];
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'View',
      label: 'View',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: AssignmentPaymentsAdminSearchParams.getViewSelectOptions(),
    },
    { fieldName: 'TpEvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TpEvaluatorEmail', label: 'Evaluator Email', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ProjectNameOrId', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedTpJobCountryCodes',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedPaymentOffices',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      disabled: (searchItem) =>
        [
          EvaluatorPaymentViewsEnum.MyOfficePendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePendingReview,
          EvaluatorPaymentViewsEnum.MyOfficeEmptyPayments,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequests,
          EvaluatorPaymentViewsEnum.PendingSupervisorApproval,
        ].includes(searchItem.View),
    },
    { fieldName: 'ThirdPartyJobId', label: 'Third-Party Job ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TpEvaluatorTpJobPaymentId', label: 'Pay ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'TypeText',
      label: 'Type',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: ThirdPartyJobPaymentsAdminSearchParams.getTypeTextSelectOptions(),
      disabled: (searchItem) =>
        [
          EvaluatorPaymentViewsEnum.MyPaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyPaymentRequests,
          EvaluatorPaymentViewsEnum.MyPaymentRequestsInformationRequired,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequests,
          EvaluatorPaymentViewsEnum.PendingSupervisorApproval,
        ].includes(searchItem.View),
    },
    {
      fieldName: 'StatusCodeLookupValue',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 45,
      disabled: (searchItem) =>
        [
          EvaluatorPaymentViewsEnum.MyOfficePendingApproval,
          EvaluatorPaymentViewsEnum.MyPaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.PendingApproval,
          EvaluatorPaymentViewsEnum.MyPaymentRequestsInformationRequired,
          EvaluatorPaymentViewsEnum.PendingSupervisorApproval,
        ].includes(searchItem.View),
    },
    {
      fieldName: 'SelectedThirdPartyJobStatuses',
      label: 'Third-Party Job Status',
      className: 'col-4',
      type: InputTypesEnum.TpJobStatusMultiSelect,
    },
    { fieldName: 'EmptyPayment', label: 'Empty Payment', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-4', type: InputTypesEnum.UserSelect },
    {
      fieldName: 'HasExportPayment',
      label: 'Has Export Payment',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];

  static getTypeTextSelectOptions() {
    return selectHelper.generateSelectValues([
      'Reprint',
      'Surcharge',
      'Refund',
      'Advance Payment',
      'Payment Request',
      'Assignment Payment',
    ]);
  }

  static getViewSelectOptions() {
    return selectHelper.generateSelectValues([
      EvaluatorPaymentViewsEnum.AllPaymentRequests,
      EvaluatorPaymentViewsEnum.MyOfficePendingApproval,
      EvaluatorPaymentViewsEnum.MyPaymentRequestsPendingApproval,
      EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
      EvaluatorPaymentViewsEnum.PendingApproval,
      EvaluatorPaymentViewsEnum.PendingReview,
      EvaluatorPaymentViewsEnum.MyOfficePendingReview,
      EvaluatorPaymentViewsEnum.MyPaymentRequests,
      EvaluatorPaymentViewsEnum.MyOfficeEmptyPayments,
      EvaluatorPaymentViewsEnum.MyPaymentRequestsInformationRequired,
      EvaluatorPaymentViewsEnum.AllEmptyPayments,
      EvaluatorPaymentViewsEnum.MyOfficePaymentRequests,
    ]);
  }

  // CD-5483: the server filters this page by SearchType, not View, so the page sends its View as the SearchType. The
  // payment tabs of a job or an evaluator (TabType set) keep their own SearchType, or none, whatever View they carry.
  cleanForBackendCall() {
    const cleaned = super.cleanForBackendCall();
    if (!this.TabType && this.View) {
      cleaned.SearchType = this.View;
    }
    return cleaned;
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'ThirdPartyJobPaymentsAdminSearchParams';
}
